import ApiService from '../api.services';

const ItemsService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/items');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/items/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {
        try {
            const data = {
                item: form
            }
            const res = await ApiService.post('/api/items', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            item: form
        }
        try {
            const response = await ApiService.put(`/api/items/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/items/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default ItemsService;

export { ItemsService };

